import type { ReactElement } from "react";
import * as React from "react";

export const ErrorCircle = (): ReactElement => (
  <>
    <circle cx="12" cy="12" r="10" fill="#E81A33" />
    <path
      d="M12 8.00006V12.0001M12 16.0001H12.01"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);
